export enum UserFormStatus {
    OPEN = 0,
    COMPLETED = 1,
    LOCKED = 2
}